import { FulfillmentPasswordService } from 'common/data';
import { action } from 'mobx';

class FulfillmentPasswordStore {
	constructor(rootStore) {
		this.service = new FulfillmentPasswordService(rootStore.app.baasic.apiClient);
	}

	@action.bound
	changePassword = async (username, oldPassword, newPassword) => {
		const response = await this.service.changePassword(username, oldPassword, newPassword);
		return response.data;
	};

	@action.bound
	sendResetPasswordCode = async params => {
		const response = await this.service.sendResetPasswordCode(params);
		return response.data;
	};

	@action.bound
	sendResetPasswordEmail = async params => {
		const response = await this.service.sendResetPasswordEmail(params);
		return response.data;
	};

	@action.bound
	resendResetPasswordEmail = async params => {
		const response = await this.service.resendResetPasswordEmail(params);
		return response.data;
	};

	@action.bound
	resetPassword = async params => {
		const response = await this.service.resetPassword(params);
		return response.data;
	};
}

export default FulfillmentPasswordStore;



// WEBPACK FOOTER //
// ./src/modules/membership/stores/FulfillmentPasswordStore.js